/**
 * Ánh xạ trạng thái → lớp chip semantic (docs/08 §8.3).
 *
 * Ba màn hình (`domains.html`, `domain-detail.html`, `index.html`) từng khai
 * cùng một bảng này; M7 gộp về một chỗ để đổi màu trạng thái chỉ phải sửa một
 * nơi. Không đổi hành vi — giá trị giữ nguyên.
 */

/** `active` → success · `pending`/`paused` → warn · `error` → danger. */
export const DOMAIN_STATUS_CHIP: Record<string, string> = {
  active: 'ok',
  pending: 'warn',
  paused: '',
  moved: 'info',
  error: 'bad',
};

/** Trạng thái kết nối Cloudflare — FR-101. */
export const CONNECTION_STATUS_CHIP: Record<string, string> = {
  ok: 'ok',
  invalid: 'bad',
  paused: 'warn',
};

export function domainStatusChip(status: string): string {
  return DOMAIN_STATUS_CHIP[status] ?? '';
}
